import { isTimelineDays } from '@rental/domain'

/**
 * W2-S S1: the span Prezzi last showed on this device, so the menu's "Prezzi"
 * opens on it again (the address still wins when it names one). Its own key:
 * the Planning's span is the Planning's. The same rules as `timeline-days.ts`:
 * a number of days only, 1 to TIMELINE_MAX_DAYS (the API's own bound),
 * validated on the way back as on the way in; storage that refuses or holds
 * nonsense means "the default", as on a new device.
 */
export const PRICES_DAYS_KEY = 'rental.staff.prices-days'

/** The span with nothing remembered and nothing in the address: two weeks, as the API's own default. */
export const PRICES_DEFAULT_DAYS = 14

/** The days this device last showed on Prezzi, or null when it remembers none it may show. */
export function readPricesDays(
  storage: Pick<Storage, 'getItem'> | null = localStore(),
): number | null {
  try {
    const value: unknown = JSON.parse(storage?.getItem(PRICES_DAYS_KEY) ?? 'null')
    return isTimelineDays(value) ? value : null
  } catch {
    return null
  }
}

/** The Owner chose a span: the next opening starts on it. */
export function rememberPricesDays(
  days: number,
  storage: Pick<Storage, 'setItem'> | null = localStore(),
) {
  if (!isTimelineDays(days)) return
  try {
    storage?.setItem(PRICES_DAYS_KEY, JSON.stringify(days))
  } catch {
    // Storage refused: the next opening shows the default, as on a new device.
  }
}

function localStore(): Storage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}
